import { render, staticRenderFns } from "./relationContent.vue?vue&type=template&id=0dee454c&scoped=true"
import script from "./relationContent.vue?vue&type=script&lang=js"
export * from "./relationContent.vue?vue&type=script&lang=js"
import style0 from "./relationContent.vue?vue&type=style&index=0&id=0dee454c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dee454c",
  null
  
)

export default component.exports